export const MOBILE_BREAKING_POINT = 1024
